'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./lange.styl');

var _index = require('../utils/index');

var _style = require('../utils/style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { FormattedMessage } from '@ali/react-intl';


var isClient = typeof window !== 'undefined';
var logger = isClient ? require('@ali/log') : {};

var Lange = function (_Component) {
  _inherits(Lange, _Component);

  function Lange(props) {
    _classCallCheck(this, Lange);

    var _this = _possibleConstructorReturn(this, (Lange.__proto__ || Object.getPrototypeOf(Lange)).call(this, props));

    _this.state = {
      tab: 'en',
      isShow: false,
      tabList: [],
      btnStyle: null,
      cornorStyle: null
    };
    _this.switchLanguage = _this.switchLanguage.bind(_this);
    return _this;
  }

  _createClass(Lange, [{
    key: 'changeLanguage',
    value: function changeLanguage(e, val) {
      var currentTab = this.state.tab;
      if (currentTab === val) return;
      e.stopPropagation();
      logger.logClick('switchLange', { lange: val });
      this.setState({
        tab: val
      });
      var url = (0, _index.getUrl)(val);
      // 为了让用户无感知跳转，用 pushState...
      window.history.pushState(null, null, url);
      // 补偿刷新
      setTimeout(function () {
        window.location.reload();
      }, 300);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.hideList !== this.props.hideList) {
        this.state.isShow = false;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          _props$tabListKey = _props.tabListKey,
          tabListKey = _props$tabListKey === undefined ? 'lange_switch.lange' : _props$tabListKey,
          bgColor = _props.bgColor,
          btnBgImg = _props.btnBgImg,
          left = _props.left,
          top = _props.top,
          btnStyle = _props.btnStyle;

      var lange = '';
      try {
        if (window.__CUTTLE_EXT_CONFIG__) {
          lange = window.__CUTTLE_EXT_CONFIG__.__intl__.locale.toLocaleLowerCase() || '';
        } else if (window.__BROCCOLI_EXT_CONFIG__) {
          lange = window.__BROCCOLI_EXT_CONFIG__.__intl__.locale.toLocaleLowerCase() || '';
        }
      } catch (e) {
        console.error(e);
      }
      var list = (0, _index.getLocale)(tabListKey);
      if (Object.prototype.toString.call(list) !== '[object Array]') return;
      var tabList = list.map(function (item) {
        var items = item.split(',');
        return {
          label: items[0],
          la: items[1].toLocaleLowerCase().trim()
        };
      });
      this.setState({
        tab: lange,
        tabList: tabList,
        btnStyle: _extends((0, _style.customBg)(btnBgImg), { left: left / 1000 + 'rem', top: top / 1000 + 'rem' }, btnStyle),
        cornorStyle: { borderColor: 'transparent transparent ' + bgColor + ' transparent' }
      });
    }
  }, {
    key: 'switchLanguage',
    value: function switchLanguage(e) {
      e.stopPropagation();
      logger.logClick('btn_language');
      this.setState(function (prevState) {
        return {
          isShow: !prevState.isShow
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          tab = _state.tab,
          isShow = _state.isShow,
          tabList = _state.tabList,
          btnStyle = _state.btnStyle,
          cornorStyle = _state.cornorStyle;
      var _props2 = this.props,
          bgColor = _props2.bgColor,
          selectBgColor = _props2.selectBgColor,
          listStyle = _props2.listStyle;

      if (tabList.length === 0) return null;
      return _react2.default.createElement(
        'div',
        { className: 'bro-language-page', onClick: this.switchLanguage, style: btnStyle },
        isShow && _react2.default.createElement('span', { className: 'corner', style: cornorStyle }),
        isShow && _react2.default.createElement(
          'div',
          { className: 'tab-list', style: listStyle },
          tabList.map(function (item, index) {
            return _react2.default.createElement(
              'span',
              { key: index, className: tab === item.la ? 'tab active' : 'tab',
                style: { backgroundColor: tab === item.la ? selectBgColor : bgColor },
                onClick: function onClick(e) {
                  _this2.changeLanguage(e, item.la);
                } },
              item.label
            );
          })
        )
      );
    }
  }]);

  return Lange;
}(_react.Component);

exports.default = Lange;